import React, { useEffect, useState } from "react";
import axios from "axios";
import { routes } from "../gen/General";
import { Button, Card, CardBody, CardFooter, CardHeader, Form } from "reactstrap";

import Alerts from "../util/Alerts";
import { Link, useHistory } from "react-router-dom";
import { Field } from "formik";
import Footer from "../components/Footer/Footer";
import logo from "assets/img/prodeseg_login.png";
import usuario from "assets/img/usuario.png";
import BlkFormik from "../util/BlkFormik";

const Recuperar = () => {
    const [item, setItem] = useState({ usuario: "" });
    const [usernameFocus, setUsernameFocus] = useState(false);

    const alert = React.useRef();
    const history = useHistory();

    useEffect(() => {
        const mailcito = sessionStorage.getItem("mailcito");
        if (mailcito) {
            setItem({ ...item, usuario: mailcito });
        }
    }, []);

    const onSubmit = (newValues, actions) => {
        let body = {
            user: newValues.usuario.toLowerCase(),
        };
        axios.defaults.withCredentials = true;
        axios
            .post(routes.api + "/reset", body)
            .then(resp => {
                alert.current.show_info(
                    "Hemos enviado una contraseña temporal a tu correo electrónico registrado; por favor cámbiala con una que sea fácil recordar en tu primer ingreso.  Si no recibes dicho correo, contáctanos a infoportal@prodeseg.com después de validar que el email no se haya ido a tu carpeta de correos no deseados."
                );
            })
            .catch(err => alert.current.handle_error(err))
            .finally(() => {
                actions.setSubmitting(false);
                setTimeout(() => {
                    history.replace("/");
                }, 5000);
            });
    };

    return (
        <>
            <div className={"col-12 col-md-7 bg-green-blur"}>
                <div className="logo-wrp">
                    <img src={logo} alt="now-logo" />
                </div>
                <BlkFormik initialValues={item} onSubmit={onSubmit} enableReinitialize={true} validateOnChange={false}>
                    {({ values, isSubmitting, errors, handleChange, resetForm, submitForm }) => (
                        <Form className={"d-flex justify-content-end flex-column align-items-end"}>
                            <Card className="card-login card-plain">
                                <CardHeader>
                                    <h3 className="mb-0 text-center text-white py-4">Recuperar contraseña</h3>
                                </CardHeader>
                                <CardBody className={"pb-0 text-center"}>
                                    <img className="img-fluid mb-2 text-white" src={usuario} alt="usr" />

                                    <Field
                                        className="form-control"
                                        name="usuario"
                                        type="text"
                                        placeholder="Usuario"
                                        onFocus={() => setUsernameFocus(true)}
                                        onBlur={() => setUsernameFocus(false)}
                                    />
                                </CardBody>
                                <CardFooter className="pt-0 mt-5">
                                    <Button
                                        block
                                        round
                                        color="white"
                                        size="lg"
                                        className="mb-3 py-1 text-primary"
                                        disabled={isSubmitting}
                                        onClick={() => submitForm()}
                                    >
                                        Recuperar
                                    </Button>
                                    <div className="text-center">
                                        <h6>
                                            <Link to="/" className="link footer-link">
                                                Iniciar sesión
                                            </Link>
                                        </h6>
                                    </div>
                                </CardFooter>
                                <div className={"separator"} />
                            </Card>
                        </Form>
                    )}
                </BlkFormik>
                <Footer fluid={true} />
            </div>
            <Alerts ref={alert} />
        </>
    );
};

export default Recuperar;
